export const GParallax = require('./classes/globalParallax').default;
export const Nearby = require('./classes/nearby').default;
export const FormControl = require('./classes/formControl').default;
export const Sticky = require('./classes/sticky').default;
export const BootstraperMaps = require('./bootstraper/maps').default;
export const BootstraperYoutube = require('./bootstraper/youtube').default;
export const utils = require('./utils');